import { ASSETS, BRAND } from "./shared";

export const Nav = () => (
  <nav
    data-testid="main-nav"
    className="sticky top-0 z-40 bg-[#1B0F2E]/90 backdrop-blur-md border-b border-[#3B2760] px-6 md:px-12 py-4 flex items-center justify-between"
  >
    <div className="flex items-center gap-3" data-testid="nav-brand">
      <img
        src={ASSETS.logo}
        alt={`${BRAND} logo`}
        className="w-20 h-20 rounded-xl object-cover"
      />
      <span className="font-bold text-sm tracking-tight uppercase">Amanda&rsquo;s Coffee and Retro Video Games</span>
    </div>
    <div className="flex items-center gap-6">
      <a
        data-testid="nav-arcade-link"
        href="#games"
        className="hidden sm:inline-block text-xs uppercase mono-lbl font-semibold hover:text-[#FF2E88] transition-colors"
      >
        Video Game Systems
      </a>
      <a
        data-testid="nav-menu-link"
        href="#menu"
        className="hidden sm:inline-block text-xs uppercase mono-lbl font-semibold hover:text-[#FF2E88] transition-colors"
      >
        Menu
      </a>
      <a
        data-testid="nav-plan-visit-btn"
        href="#visit"
        className="px-4 py-2 rounded-full bg-[#FF2E88] text-white text-xs font-bold uppercase mono-lbl tracking-wider hover:bg-[#D61F73] transition-colors"
      >
        Plan Visit
      </a>
    </div>
  </nav>
);
